import React from 'react'

import NewsNovEd from '../files/newsletter-nov-dec-2019.pdf'
import NewsOctEd from '../files/newsletter-oct-2019.pdf'
import NewsOctEdImg from '../images/newsletter-oct-2019.png'
import NewsNovEdImg from '../images/newsletter-nov-2019.png'

import Layout from '../components/layout'

const NewsletterPage = () => (
  <Layout>
    <section className="mw7 center">
    <h1 className="ph3 ph0-l bb bw2 pb3">The Riverton Arts Newsletter</h1>
    <article className="pv4 bb b--black-10 ph3 ph0-l">
      <div className="flex flex-column flex-row-ns">
        <div className="w-100 w-60-ns pr3-ns order-2 order-1-ns">
          <h2 className="f3 mt0 lh-title">
            <a href={NewsNovEd} target="_blank">
              Nov - Dec 2019 Newsletter
            </a>
          </h2>
          <p className="measure">
            The Arts Centre has a very busy season ahead. The Steampunk Exhibition which has just finished, was visited by over 900 people during October and November. A significant number of sales were made, which is great for the artists and the Arts Centre.
          </p>
        </div>
        <div className="pl3-ns order-1 order-2-ns mb4 mb0-ns w-100 w-40-ns">
          <img src={NewsNovEdImg} className="db" alt="Riverton Arts newsletter for Nov Dec 2019" />
        </div>
      </div>
    </article>
    <article className="pv4 bb b--black-10 ph3 ph0-l">
      <div className="flex flex-column flex-row-ns">
        <div className="w-100 w-60-ns pr3-ns order-2 order-1-ns">
          <h2 className="f3 mt0 lh-title">
            <a href={NewsOctEd} target="_blank">
              Oct Newsletter
            </a>
          </h2>
          <p className="measure">          
            The past month has been a very exciting time. Wayne of the Hill invented a Time Machine (which he assures me works) and many visitors have tried it out. The four year children from the Navigator Room at the Riverton Childcare Cen- tre delivered a Steampunk hat, googles and jacket. While they were at the Cen- tre the children went looking for dinosaurs, sadly the machine was not at it’s best on the day and no dinosaurs were found. The time machine is up for auc- tion. You can bid at the Arts Centre or on Trade Me.
          </p>
        </div>
        <div className="pl3-ns order-1 order-2-ns mb4 mb0-ns w-100 w-40-ns">
          <img src={NewsOctEdImg} className="db" alt="Riverton Arts newsletter for October 2019" />
        </div>
      </div>
    </article>
  </section>
  </Layout>
)

export default NewsletterPage
